// # IMPORTS
// * Import required lib
import { useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ReactGA from "react-ga4";
import NoAccess from "./screens/NoAccess/NoAccess";
// * Custom Components
import AppRoutes from "./routes/AppRoutes";
import Loader from "../js/components/Loader";

// * Import utils
import { getUserInfo } from "./services/api";
import {
  loginSuccessful,
  loginFailed,
  setNewUser,
} from "./redux/slice/authSlice";
import {
  toggleRecommendation,
  updateTheme,
  updateDiscoverActiveTab,
  updateUserFilters,
  updateViewType,
} from "./redux/slice/selectionsSlice";
import APP_CONSTANTS, { API_ENDPOINTS } from "./utils/config";
import { updateUserDataModel } from "./redux/slice/dataSlice";

// # COMPONENT
function App() {
  // # HOOKS
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const path = useLocation();
  const unauthenticatedPaths = ["/no-access"];

  // # SELECTORS
  const auth = useSelector((state) => state.auth);

  // # SIDE EFFECTS
  useEffect(() => {
    const getUserInfoApi = async () => {
      try {
        dispatch(
          updateUserFilters({
            result: {},
            status: APP_CONSTANTS.LOADING,
            message: "",
          })
        );
        const response = await getUserInfo();
        dispatch(
          updateUserFilters({
            result: response.data.data.filter_info,
            status: APP_CONSTANTS.SUCCESS,
            message: "",
          })
        );
        dispatch(loginSuccessful(response.data.data));

        dispatch(updateViewType(response.data.data.tile_type));
        dispatch(updateTheme(response.data.data.theme));
        dispatch(toggleRecommendation(response.data.data.show_recommendation));

        dispatch(updateDiscoverActiveTab(response.data.data.default_tab));
        dispatch(
          updateUserDataModel({
            result: response.data.data.user_data_models,
            status: APP_CONSTANTS.SUCCESS,
            message: "",
          })
        );
        if (!response.data.data.completed_signup) {
          dispatch(setNewUser(true));
          navigate("/account-setup");
        } else {
          const pathName =
            window.location.pathname === "/account-setup"
              ? "/discover"
              : path.pathname + path.search;
          navigate(pathName);
        }
        // navigate("/account-setup");
      } catch (err) {
        dispatch(loginFailed());
        // window.location.href = `${API_ENDPOINTS.signinUrl}?redirect_path=${
        //   path.pathname + path.search
        // }`;
      }
    };
    if (!unauthenticatedPaths.includes(path.pathname)) {
      getUserInfoApi();
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: window.location.pathname + window.location.search,
    });
  }, []);

  return (
    <>
      {["loading", "initial"].includes(auth.status) &&
        !unauthenticatedPaths.includes(path.pathname) && (
          <Loader message={"Authenticating user"} />
        )}

      <Routes>
        <Route path="/no-access" element={<NoAccess />} exact />
      </Routes>

      {auth.status === "success" && <AppRoutes />}
    </>
  );
}

// # EXPORTS
export default App;
